import React, {useContext, useEffect, useState} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {Button, Form, Input, Select} from 'antd';
import PropTypes from 'prop-types';
import './applicationEdit.scss';

import ApplicationTemplate from "../../../components/applicationTemplate/applicationTemplate";
import {applicationUpdate, template} from "../../../apis/admin";
import {replaceUrlByParams} from "../../../utils/api";
import {valueToSubmit} from "../../../components/mapToTemplate";
import {PAGE} from "../../../utils/constants";
import {AppContext} from "../../../App";

ApplicationEditPage.propTypes = {
    location: PropTypes.object,
    state: PropTypes.object,
};

function ApplicationEditPage(props) {
    let history = useHistory()
    const {pid, id} = useParams()
    const [q, setQ] = useState([])
    const {setLoading} = useContext(AppContext)
    const [form] = Form.useForm();

    useEffect(() => {
        if(props.location.state && props.location.state.formValue){
            getApplicationTemplate();
            form.setFieldsValue(props.location.state.formValue);
        }else {
            history.goBack();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getApplicationTemplate = async () => {
        setLoading(true)
        try {
            const res = await template(pid); //admin template
            if (res.error) {
                throw new Error(`${res.error.msgCode} - ${res.error.message}`);
            } else {
                setQ(res)
            }
        } catch (e) {
            console.error(e);
        }finally {
            setLoading(false)
        }
    };

    const onFinish = async (value) => {
        value = Object.keys(value).filter( e => value[e] !== undefined).reduce((acc, curr) => { //filter unless key
            return {
                ...acc,
                [curr]: value[curr]
            }
        }, {})

        const submitData = valueToSubmit(value)
        try {
            let res = await applicationUpdate(pid, id, submitData);
            if (res.error) {
                throw new Error(`${res.error.msgCode} - ${res.error.message}`);
            } else {
                history.push({
                    pathname: `${replaceUrlByParams(PAGE.ADMIN_APPLICATION_DETAIL, {':pid': pid, ':id': id} )}`,
                });
            }
        } catch (e) {
            console.error(e);
        }
    };

    const onFinishFailed = errorInfo => {
        // console.log('Failed:', errorInfo);
    };

    return (
        <div className='application-edit-page'>
            <Form
                form={form}
                layout='vertical'
                labelAlign='left'
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
            >

                <ApplicationTemplate
                    template={q}
                    form={form}
                />

                <div className='button-container'>
                    <Button onClick={() => history.goBack()}>取消</Button>
                    <Form.Item>
                        <Button type="primary" htmlType="submit">儲存</Button>
                    </Form.Item>
                </div>
            </Form>

        </div>
    )
}

export default ApplicationEditPage;
